interface TeachingCommandMessage {
  roomId: string | null;
  zoneId: string | null;
  zoneName: string | null;
  zonePoints?: number[][];
  zoneStartPosition?: number[];
  type: TeachingCommand;
}

export enum TeachingCommand {
  StartTeaching = "StartTeaching",
  SetStartPosition = "SetStartPosition",
  SaveAndEndTeaching = "SaveAndEndTeaching",
  AbortTeaching = "AbortTeaching",
  AutoGeneratePath = "AutoGeneratePath",
}

export const teachingCommandMessagesEqual = (
  msg1: TeachingCommandMessage,
  msg2: TeachingCommandMessage
) => {
  return msg1.roomId === msg2.roomId && msg1.zoneId === msg2.zoneId && msg1.type === msg2.type;
};

export const isTeachingCommandMessage = (input: any): input is TeachingCommandMessage => {
  return "roomId" in input && "zoneId" in input && "zoneName" in input && "type" in input;
};

export default TeachingCommandMessage;